import React from "react";
import { useLogStreamEvents } from "@api/logStream.api";
import { Loader } from "@design-system/Loader/Loader";
import "./SecuritySettings.scss";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { LogStreamEventRow } from "./LogStreamEventRow";

export const SecuritySettings: React.FC = () => {
    const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading } =
        useLogStreamEvents();

    const events = data?.pages.flatMap((p) => p.data);

    if (isLoading) {
        return <Loader />;
    }

    return (
        <div className="settings__security">
            <header className="settings__header">
                <h3>Activity history</h3>
            </header>

            <section className="log-stream-events">
                <table className="table log-stream-events__list mb-0">
                    <thead>
                        <tr>
                            <th>Event</th>
                            <th>Browser</th>
                            <th>IP</th>
                            <th>Date and time</th>
                            <th>Country</th>
                        </tr>
                    </thead>

                    <tbody>
                        {events && events.length > 0 ? (
                            events.map((event) => (
                                <LogStreamEventRow
                                    log={event}
                                    key={event.logId}
                                />
                            ))
                        ) : (
                            <tr>
                                <td colSpan={99}>
                                    <EmptyState header="No activity history" />
                                </td>
                            </tr>
                        )}
                    </tbody>

                    {hasNextPage && (
                        <tfoot className="text-center">
                            <tr>
                                <td colSpan={5}>
                                    <ButtonWithLoader
                                        variant="secondary"
                                        size="sm"
                                        onClick={() => {
                                            void fetchNextPage();
                                        }}
                                        loading={isFetchingNextPage}
                                    >
                                        View more
                                    </ButtonWithLoader>
                                </td>
                            </tr>
                        </tfoot>
                    )}
                </table>
            </section>
        </div>
    );
};
